
import Vue from 'vue'
import DrawerMenu from '@/components/globalHeader/DrawerMenu.vue'
// import HeaderSearch from '@/components/globalHeader/HeaderSearch.vue'
import ProfileModal from '@/components/globalHeader/ProfileModal.vue'
import { CommonData } from '@/types/commonData'
import { SELECTION_PATHS, MOBILE_SCREEN_SIZE } from '@/constants/index'
export default Vue.extend({
  components: {
    DrawerMenu,
    ProfileModal
    // HeaderSearch
  },
  props: {
    commonData: {
      type: Object as () => CommonData,
      required: true
    },
    currentUser: {
      required: true,
      validator: v => typeof v === 'object' || v === null
    },
    orderHistoryCount: {
      type: Number,
      required: true
    }
  },
  data(): {
    menuVisible: boolean
    profileModalVisible: boolean
    customClass: string
  } {
    return {
      menuVisible: false,
      profileModalVisible: false,
      customClass: ''
    }
  },
  computed: {
    isMobileView(): boolean {
      return window.innerWidth < MOBILE_SCREEN_SIZE
    },
    isHeaderSticky(): boolean {
      const firstPath = window.location.pathname.split('/')[1]
      return !SELECTION_PATHS.includes(firstPath) && this.isMobileView
    }
  },
  mounted() {
    if (!this.isHeaderSticky) {
      const affixTarget = document.getElementsByClassName('gh-Mobile_Section-search')[0] as HTMLElement
      const mainTarget = (document.getElementsByClassName('lp-main')[0] || document.getElementsByClassName('global-main')[0]) as HTMLElement
      const startPosition = affixTarget.offsetTop
      if (!affixTarget || !mainTarget) return
      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY
        if (scrollY < startPosition){
          this.customClass = 'gh-Mobile_sticky'
          mainTarget.style.marginTop = '0'
        }
        else {
          this.customClass = 'gh-Mobile_fixed'
          mainTarget.style.marginTop = '52px'
        }
      })
    }
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible
      if (this.menuVisible) {
        this.disablePageScroll()
      } else {
        this.enablePageScroll()
      }
    },
    disablePageScroll() {
      document.querySelector('body')!.classList.add('is-locked')
    },
    enablePageScroll() {
      document.querySelector('body')!.classList.remove('is-locked')
    },
    toggleProfileModal() {
      this.profileModalVisible = !this.profileModalVisible
      if (this.profileModalVisible) {
        this.disablePageScroll()
      } else {
        this.enablePageScroll()
      }
    }
  }
})
